import React from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import { Roles } from '../../../core/util';
import notificationService from '../../../core/services/NotificationService';

const CompanyList = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      {
        label: 'Name',
        path: 'name',
        sort: true,
      },
      ...(localStorage.getItem('role') !== Roles.DISTRIBUTOR_MANAGER
        ? [
            {
              label: 'Social Reason',
              path: 'socialReason',
              width: '300px',
            },
          ]
        : []),
      {
        label: 'Document Number',
        path: 'cnpj',
        width: '150px',
      },
      ...([Roles.ADMIN, Roles.SUPPORT].includes(localStorage.getItem('role'))
        ? [
            {
              label: 'Segment',
              path: 'segment.name',
            },
            {
              label: 'Distributor',
              path: 'distributor.name',
              width: '200px',
            },
          ]
        : []),
      {
        label: 'Actions',
        path: 'action',
        width: localStorage.getItem('role') === 'ADMIN' ? '125px' : '105px',
        render: (cell, row) => {
          return (
            <div>
              {!row.contract && (
                <>
                  <Button icon="delete" onClick={() => props.onDelete(row)} />{' '}
                </>
              )}
              <Button icon="edit" onClick={() => browserHistory.push(`${props.baseUrl}/companies/${row.id}`)} />
              {localStorage.getItem('role') === 'ADMIN' && (
                <React.Fragment>
                  {' '}
                  <Button
                    icon="dashboard"
                    onClick={() =>
                      browserHistory.push(
                        `/kpis/customer-success/distributor/${row.distributor}/company/${row.id}/details`
                      )
                    }
                  />
                </React.Fragment>
              )}
            </div>
          );
        },
      },
    ]}
    selectable
    rows={props.companies}
    pagination={props.pagination}
    onSelect={(row) => {
      if (row.apiVersion === 'V2') {
        notificationService.addNotification(
          'Unable to select this company as it makes part of the new admin platform.',
          'info'
        );
      } else {
        browserHistory.push(`${props.baseUrl}/companies/${row.id}/details`);
      }
    }}
    onChange={props.onChange}
  />
);

CompanyList.propTypes = {
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  baseUrl: PropTypes.string.isRequired,
  fetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  pagination: PropTypes.shape({}).isRequired,
};

export default CompanyList;
